export default __webpack_public_path__ + "static/media/Food.096d8d35.png";